import apiClient from './client';
import { LoginResponse, User } from '../types/campaign.types';

export const authApi = {
    login: async (email: string, password: string): Promise<LoginResponse> => {
        const response = await apiClient.post<LoginResponse>('/api/auth/login', { email, password });
        return response.data;
    },
    me: async (): Promise<User> => {
        const response = await apiClient.get<User>('/api/auth/me');
        return response.data;
    },
    bootstrapAdmin: async (data: {
        email: string;
        full_name: string;
        password: string;
    }): Promise<User> => {
        const response = await apiClient.post<User>('/api/auth/bootstrap-admin', {
            ...data,
            role: 'admin',
        });
        return response.data;
    },
};

export default authApi;
